export const ROUTE_PARAM_PLATFORM_NAME = 'platformName';

export const QUERY_REDIRECT_URL = 'redirect-url';
export const QUERY_LOCALE = 'locale';
export const QUERY_ERROR = 'error';
export const QUERY_SESSION_TOKEN = 'session-token';
export const QUERY_APP_TOKEN = 'app-token';
export const QUERY_FROM_ORIGIN = 'from-origin';
export const QUERY_ACCOUNT_ID = 'ad-account-id';
export const QUERY_ID_TOKEN = 'id-token';
export const QUERY_REASON = 'reason';
export const QUERY_STATE = 'state';

export enum AppOrigin {
	DIGITALEO = 'digitaleo',
	KAMPN = 'kampn'
}
